/** create enum from id and value, support empty value */
export const enumCreate = (enumList: string, enumValue?: string): string => {
	return `${enumList}:${enumValue || ""}`;
};
